module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--30.beac55de.png";